import { GzDialog, GzDialogEvents } from '../../ui/gzDialog/component/GzDialog';
import { GzDialogWebComponent } from '../../ui/gzDialog';
import { ConnectionOptions, DetectionRuleType, EmailOptions, Operators, ResourceOptions } from '../customRulesGrid/types';
import { isIP } from 'is-ip';
import { isEmail } from 'class-validator';

export const createDialog = dialogOptions => {
  const {
    headline,
    textContent,
    confirmButtonText,
    cancelButtonText,
    confirmCallback,
  } = dialogOptions;

  const dialogBody = document.createElement('div');
  dialogBody.innerHTML = `<p>${textContent}</p>`;

  const dialogFooter = document.createElement('div');

  dialogFooter.innerHTML = `
    <gz-button id="buttonOne" type="outline" color="negative">${confirmButtonText}</gz-button>
    <gz-button id="buttonTwo" type="outline" color="secondary">${cancelButtonText}</gz-button>
    `;

  const footerBtnOne = dialogFooter.querySelector('#buttonOne');
  const footerBtnTwo = dialogFooter.querySelector('#buttonTwo');

  const dialogConfigs: GzDialog = {
    headline,
    bodyContent: dialogBody,
    footerContent: dialogFooter,
    isOpen: true,
  };

  const dialog = GzDialogWebComponent.buildDialogElement(dialogConfigs);
  dialog.addEventListener(GzDialogEvents.CONFIRM, confirmCallback);

  if (footerBtnOne) {
    footerBtnOne.addEventListener('click', () => {
      dialog.close();
      dialog.emitDialogEvent(GzDialogEvents.CONFIRM);
    });
  }

  if (footerBtnTwo) {
    footerBtnTwo.addEventListener('click', () => {
      dialog.dismiss();
    });
  }
};

export const validateRule = (ruleCriteria, queryType) => {
  return (
    ruleCriteria.criteriaValue != null &&
    ruleCriteria.operatorValue != null &&
    validateInputValue(ruleCriteria.inputValue, queryType, ruleCriteria.criteriaValue, ruleCriteria.operatorValue)
  );
};

export const validateAlert = (ruleCriteria) => {
  return (
    ruleCriteria.operatorValue === Operators.IS
  );
};

const validateConnection = (criteria: ResourceOptions, inputValue, operator: Operators) => {
  if (
    operator === Operators.IS &&
    (criteria === ConnectionOptions.SOURCE_IP || criteria === ConnectionOptions.DESTINATION_IP)
  ) {
    return isIP(inputValue as string);
  }

  if (criteria === ConnectionOptions.SOURCE_PORT || criteria === ConnectionOptions.DESTINATION_PORT) {
    if (Array.isArray(inputValue)) {
      return (inputValue as string[]).every(value => parseInt(value, 10).toString() === value);
    }

    return parseInt(inputValue as string, 10).toString() === inputValue;
  }
  return true;
};

const validateEmail = (criteria: ResourceOptions, inputValue, operator: Operators) => {
  if (
    operator === Operators.IS &&
    (criteria === EmailOptions.SENDER || criteria === EmailOptions.RECEIVER)
  ) {
    if (Array.isArray(inputValue)) {
      return isEmail(inputValue[0]);
    } else {
      return isEmail(inputValue);
    }
  }
  return true;
};

const validateByQueryType = (
  queryType,
  criteria: ResourceOptions,
  inputValue,
  operator: Operators) => {
  switch (queryType) {
    case DetectionRuleType.CONNECTION:
      return validateConnection(criteria, inputValue, operator);

    case DetectionRuleType.EMAIL:
      return validateEmail(criteria, inputValue, operator);

    default:
      return true;
  }
};

export const validateInputValue = (
  inputValue: string | string[] | null,
  queryType: string | number,
  criteria: ConnectionOptions,
  operator: Operators,
) => {
  if (inputValue === null || inputValue.length === 0) {
    return false;
  }
  return validateByQueryType(queryType, criteria, inputValue, operator);
};
